import React from 'react';
import ReactDOM from 'react-dom';
import UPshowState from '../UPshowState';
import StateFactory from '../StateFactory';

function Inactive () {
    return <div className="Inactive">
        <div className="logo">
            <img alt="logo" src="https://cdn.upshow.tv/ui4_assets/UPshow_logo_primary-reverse.png"/>
        </div>
        <div className="first">Please contact UPshow Support<br/>to reactivate your device</div>
        <div className="second">
            Email support@upshow.tv
        </div>
    </div>;
}

class InactiveState extends UPshowState {

    get name () {
        return 'inactive';
    }

    preload () {
        ReactDOM.render(<Inactive/>, this.node);

        return super.preload();
    }
}

StateFactory.register('inactive', InactiveState, 10);

export default InactiveState;
